function initAutoScroll() {
    const isMobile = window.innerWidth < 750;

    const sections = document.querySelectorAll('[data-mobile-carousel="true"]');

    sections.forEach(section => {
        const container = section.querySelector('.swipe__wrapper');
        if (!container) return;

        // 👉 if desktop → reset again (don't run)
        if (!isMobile) {
            container.innerHTML = container.dataset.originalHtml || container.innerHTML;
            container.dataset.autoInit = '';
            return;
        }

        // 👉 save original HTML (only save 1 time)
        if (!container.dataset.originalHtml) {
            container.dataset.originalHtml = container.innerHTML;
        }

        if (container.dataset.autoInit) return;
        container.dataset.autoInit = 'true';

        const originalItems = Array.from(container.children);
        if (originalItems.length <= 1) return;

        // 👉 clone full list
        originalItems.forEach(item => {
            container.appendChild(item.cloneNode(true));
        });

        let interval;
        let isPaused = false;

        function getItemWidth() {
            return container.firstElementChild?.offsetWidth || 0;
        }

        function start() {
            stop();

            interval = setInterval(() => {
                if (isPaused) return;

                const w = getItemWidth();
                if (!w) return;

                container.scrollBy({
                    left: w,
                    behavior: 'smooth'
                });
            }, 3000);
        }

        function stop() {
            clearInterval(interval);
        }

        function handleLoop() {
            const half = container.scrollWidth / 2;

            if (container.scrollLeft >= half) {
                container.style.scrollBehavior = 'auto';
                container.scrollLeft -= half;

                requestAnimationFrame(() => {
                    container.style.scrollBehavior = 'smooth';
                });
            }
        }

        container.addEventListener('scroll', handleLoop);

        container.addEventListener('touchstart', () => {
            isPaused = true;
            stop();
        });

        container.addEventListener('touchend', () => {
            isPaused = false;
            setTimeout(start, 1500);
        });

        start();
    });
}

// init
document.addEventListener('DOMContentLoaded', initAutoScroll);
document.addEventListener('shopify:section:load', initAutoScroll);

// 👉 important: handle resize
window.addEventListener('resize', () => {
    clearTimeout(window.__autoScrollResize);
    window.__autoScrollResize = setTimeout(() => {
        initAutoScroll();
    }, 300);
});